import { useTranslation } from 'react-i18next';
import React from 'react';
import VoiceAgentCardContent from './VoiceAgentCardContent.tsx';

const VoiceAgentSummaryFormFields = ({ form }) => {
    const { t } = useTranslation('voice_agents');
    const values = form.getValues();

    return (
        <div className="flex flex-col gap-6">
            <div className="rounded-lg border border-line-weak bg-surface-weak p-6">
                <VoiceAgentCardContent
                    name={values.name || t('summary.unnamedAgent')}
                    language={values.language}
                    phoneNumber={values.phoneNumber}
                    enabledTools={values.enabledTools || []}
                />
            </div>
            <p className="text-sm text-content-medium">{t('summary.info')}</p>
        </div>
    );
};

export default VoiceAgentSummaryFormFields;
